import React, { useState, useEffect } from 'react';
import styles from './SubscriptionCancleModal.module.css';

import { InnocodePaymentCardInfo, InnocodePaymentPasswordButton, InnocodePaymentPasswordDot } from '@intsoft/innocode-payment';
import { InnocodeButton, InnocodeCheckmark, InnocodeDropdown, InnocodeLoading, useModal, useDialog } from '@intsoft/innocode-core';
import { SubscriptionCancleReasonModal } from './SubscriptionCancleReasonModal';


/* 구독 해지 모달 */
interface SubscriptionCancleModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm?: (data: any) => void;
}

export const SubscriptionCancleModal: React.FC<SubscriptionCancleModalProps> = (props: SubscriptionCancleModalProps) => {

    const { showInnocodeModal: showBottomModal } = useModal();

    const handleCancle = () => {
        showBottomModal({
            enableDefaultStyle: true,
            headerBuilder: () => { return <></>; },
            contentBuilder: (
                _data: any,
                _handleSave: any,
                _handleDelete: any,
                _handleUpdate: any,
                handleClose: any,
                _modalType: any
            ) => {
                return <SubscriptionCancleReasonModal
                    isOpen={true}
                    onClose={handleClose}
                    onConfirm={(data: any) => {
                        handleClose();
                        props.onConfirm?.({
                            reason: data.reason,
                            otherReason: data.otherReason,
                        });
                    }}
                />;
            }
        });
    }

    return (
        <div className={styles.layoutContainer}>
            <div className={styles.editorHeader}>
                <div className={styles.editorHeaderCloseButton} onClick={props.onClose}>
                    <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" onClick={props.onClose} style={{ cursor: 'pointer' }}>
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                    </svg>
                </div>
            </div>
            <div className={styles.scrollContentArea}>
                <div className={styles.minHeightArea}>
                    <div className={styles.contentAreaWrapper}>
                        <div className={styles.contentArea}>
                            <div className={styles.contentAreaTitle}>
                                <h1 className={`innocode-typography--headline-sm innocode-typography--bold ${styles.contentAreaTitleText}`}>
                                    구독을 해지하시겠어요?
                                </h1>
                                <p className={styles.contentAreaTitleDescription}>
                                    프로 멤버십을 해지하시면 아래 혜택들을 이용할 수 없게 돼요.<br />그래도 해지하시겠어요?
                                </p>
                            </div>
                            <div className={styles.subscriptionCancleWrapper}>
                                <div className={styles.subscriptionCancleItemWrapper}>
                                    <p className={styles.subscriptionCancleTitle + " innocode-typography--headline-xs innocode-typography--bold"}>
                                        프로 멤버십
                                    </p>
                                    <div className={styles.subscriptionCancleItemList}>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 1</p>
                                        </div>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 2</p>
                                        </div>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 3</p>
                                        </div>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 4</p>
                                        </div>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 5</p>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.subscriptionCancleItemWrapper}>
                                    <p className={styles.subscriptionCancleTitle + " innocode-typography--headline-xs innocode-typography--bold"}>
                                        <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                                            <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm9.408-5.5a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z" clip-rule="evenodd" />
                                        </svg>

                                        해지하면 아래 예택만 이용할 수 있어요
                                    </p>
                                    <div className={styles.subscriptionCancleItemList}>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 1의 다운그레이드 버전</p>
                                        </div>
                                        <div className={styles.subscriptionCancleItem}>
                                            <InnocodeCheckmark checked={true} />
                                            <p>혜택 2의 다운그레이드 버전</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.actionButtonWrapper}>
                                <InnocodeButton size={"xl"} className={styles.actionButton} onClick={props.onClose}>구독 계속 유지하기</InnocodeButton>
                                <InnocodeButton size={"xl"} className={styles.actionButton} theme="solid" designType="assistive" onClick={handleCancle}>구독 해지</InnocodeButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};